import React from 'react';
import { Link } from 'react-router-dom';
import Pagination from './Pagination';

interface ListProps {
  isLoading: boolean;
  title: string;
  newItemUrl: string;
  withTitle?: boolean;
  withNewAction?: boolean;
  withNewActionTargetBlank?: boolean;
  withPagination?: boolean;
  children: React.ReactNode;
  filter?: React.ReactNode;
}

export default function List({
  isLoading,
  newItemUrl,
  children,
  filter,
  title,
  withTitle = true,
  withNewAction = true,
  withNewActionTargetBlank = false,
  withPagination = false,
}: ListProps) {
  return (
    <>
      <header className='d-flex justify-content-between align-items-center placeholder-wave'>
        {withTitle && (
          <h1>
            <span>{title}</span>
          </h1>
        )}
        {withNewAction && (
          <Link
            to={newItemUrl}
            className={`btn btn-primary ${
              isLoading && 'placeholder disabled col-1'
            }`}
            target={withNewActionTargetBlank ? '_blank' : '_self'}
          >
            {!isLoading && 'Novo'}
          </Link>
        )}
      </header>

      <main>
        {filter && filter}
        {isLoading ? (
          <div className='placeholder-glow'>
            <span className='placeholder placeholder-lg col-12' />
            <span className='placeholder placeholder-xs col-12 bg-dark' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
          </div>
        ) : (
          <>
            <div className='table-responsive'>{children}</div>
            {withPagination && <Pagination total={115} />}
          </>
        )}
      </main>
    </>
  );
}
